import { useEffect, useState,useContext } from "react";
import { Typography, Box, Drawer, TextField } from "@mui/material";
import { WelcomeCampaignContext } from "../../../../context/PatientContext/WelcomeCampaignContext/WelcomeCampaignContext";
import TableTools from "../Complements/TableTools";
import ColumnSelector from "../Complements/ColumnSelector";
import { columnsWelcomeCampaign } from '../../../../themes/ColumsTools';
import WelcomeCampaignDetail from "./WelcomeCampaignComp/WelcomeCampaignDetail";



    
const WelcomeCampaign2 = () => {

  const {
    welcomeCampaignSummary: rows,
    loading,
    page,
    pageSize,
    setPage,
    setPageSize,
    total
  } = useContext(WelcomeCampaignContext);

    //const [selectedCenter, setSelectedCenter] = useState('All');
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [openReferralForm, setOpenReferralForm] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({});

    const handleAddPatient = (newPatient) => {
        // setData(prev => {
        //     const exists = prev.some(patient => patient.MemberID === newPatient.MemberID);
        //     if (exists) {
        //     // Reemplazar el paciente existente por el nuevo
        //     return prev.map(patient =>
        //         patient.MemberID === newPatient.MemberID ? newPatient : patient
        //     );
        //     } else {
        //     // Agregar el nuevo paciente al final
        //     return [...prev, newPatient];
        //     }
        // });
        console.log('Averiguar')
    };

const handleRowClick = (row) => {
  const mappedRow = {
    CipID: row.cipId,
    Campaign: row.campaign,
    MemberID: row.memberId,
    MemberName: row.fullName,
    PatientStatus: row.patientStatus,
    Language: row.language ?? 'Pendiente',
    MemberPhoneNumber: row.phoneNumber ?? 'Pendiente',
    MemberMobileNumber: row.mobileNumber ?? 'Pendiente',
    Email: row.email ?? '',
    AddressLine1: row.addressLine1 ?? '',
    AddressLine2: row.addressLine2 ?? '',
    WelcomeCampaignOptions: row.campaignOptions ?? [],
    Status: row.campaignStatus ?? 'Pendiente',
    ReleatedComments: Array.isArray(row.relatedComments) ? row.relatedComments : [],
    OfficeLocation: row.medicalCenter ?? 'Pendiente',
    NeedToRegisterOEP: row.regOepCampOpt ?? 'NO',
    OEPOptions: row.oepOptions ?? '',
    StaffName: 'Pendiente', // Puedes ajustar si hay info de usuario logueado
    PCPSpecialty: '',
    JobPossition: '',
    // Puedes agregar más campos si se obtienen luego
  };

  setSelectedPatient(mappedRow);
  setOpenReferralForm(true);
};


    //const[data,setData]=useState([])
    useEffect(() => {
        //const Information = getWelcomeCampaignMap();
        //setData(Information.data);
        //setAlldata(Information)
        //setWelcomeCampaign(Information.medicalCenters);
    }, []);

    
  return (
    <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
            Welcome Campaign
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
            <TextField
                placeholder="Member Name"
                size="small"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ width: '60%' }}
            />
            <ColumnSelector
                columns={columnsWelcomeCampaign}
                columnVisibilityModel={columnVisibilityModel}
                setColumnVisibilityModel={setColumnVisibilityModel}
            />
        </Box>
        <Box sx={{ borderBottom: '1px solid #ddd', mb: 2 }} />
        {/* Contenedor principal en fila */}
        <Box sx={{ display: 'flex', gap: 2 }}>



            {/* Contenido principal con la tabla */}
            <Box sx={{ 
                    height: 700, 
                    overflowY: "auto"
                    }}>
                <TableTools
                    rows={rows}
                    loading={loading}
                    page={page}
                    pageSize={pageSize}
                    rowCount={total}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    columns={columnsWelcomeCampaign}
                    onRowClick={handleRowClick}
                    columnVisibilityModel={columnVisibilityModel}
                    setColumnVisibilityModel={setColumnVisibilityModel}
                />
            </Box>
        </Box>
        <Drawer anchor="right" open={openReferralForm} onClose={() => setOpenReferralForm(false)}>
        <Box width={650} p={3}>
            <WelcomeCampaignDetail
            modificar={selectedPatient ?? {}}
            open={openReferralForm}
            onClose={() => setOpenReferralForm(false)}
            onSave={(newReferral) => {
                handleAddPatient(newReferral);
                setOpenReferralForm(false);
            }}
            />
        </Box>
        </Drawer>
    </Box>
    
  );
};


export default WelcomeCampaign2;

